import { Box, Flex, Link } from '@chakra-ui/react';
import { Avatar, Text } from '@kula-ai/components';
import { Card } from '../primitives';
import type { ContactCardData, ContactListBlockData } from '../../../types';

interface ContactListBlockProps {
  data: ContactListBlockData;
}

const ContactCard = ({ contact }: { contact: ContactCardData }) => (
  <Card>
    <Flex align="center" gap="10px">
      <Avatar name={contact.name} shape="circle" size={34} />
      <Box flex="1" minW={0}>
        <Text variant="span" className="text-secondary-900 font-semibold">
          {contact.name}
        </Text>
        {contact.email && (
          <Text
            variant="small"
            className="text-secondary-500"
            style={{ marginTop: 1 }}
          >
            {contact.email}
          </Text>
        )}
      </Box>
      {contact.url && (
        <Link
          href={contact.url}
          isExternal
          color="primary-500"
          onClick={(e) => e.stopPropagation()}
          flexShrink={0}
        >
          <Text variant="small" className="font-medium text-primary-500">
            View contact ↗
          </Text>
        </Link>
      )}
    </Flex>
  </Card>
);

// A list of contacts that were just created from uploaded resumes — one card
// each, with a link to the new candidate record.
export const ContactListBlock = ({ data }: ContactListBlockProps) => {
  if (!data.contacts?.length) return null;
  return (
    <Flex direction="column" gap="8px" maxW="520px">
      {data.summary && (
        <Text variant="small" className="text-secondary-500">
          {data.summary}
        </Text>
      )}
      {data.contacts.map((contact) => (
        <ContactCard key={contact.id} contact={contact} />
      ))}
    </Flex>
  );
};
